/*
 * Copyright (c) 2020. American Express Company
 */

export enum ReportType {
    INCOME_AND_EXPENSE = 'incomeAndExpense',
    ASSET_AND_DEBT = 'assetAndDebt',
    NETWORTH = 'networth'
}
